'use client';

import Image from 'next/image';
import { useState } from 'react';
import PopupForm from './PopupForm';

type HeaderProps = {
  logoSrc?: string;
  logoAlt?: string;
};

export default function Header({
  logoSrc = '/images/logo.png',
  logoAlt = 'TSO logo',
}: HeaderProps) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  return (
    <>
      <header data-component-id="src/components/ui/Header.tsx:20:6" data-component-path="src/components/ui/Header.tsx" data-component-line="20" data-component-end-line="58" data-component-file="Header.tsx" data-component-name="header" data-component-content="%7B%22elementName%22%3A%22header%22%2C%22className%22%3A%22fixed%20top-0%20z-50%20w-full%20bg-%5B%23363636%5D%22%7D" className="fixed top-0 z-50 w-full bg-[#363636]">
        <div data-component-id="src/components/ui/Header.tsx:21:8" data-component-path="src/components/ui/Header.tsx" data-component-line="21" data-component-end-line="57" data-component-file="Header.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22mx-auto%20flex%20min-h-%5B60px%5D%20max-w-%5B1440px%5D%20items-center%20justify-between%20px-4%20sm%3Amin-h-%5B70px%5D%20md%3Amin-h-%5B80px%5D%20lg%3Amin-h-%5B90px%5D%22%7D" className="mx-auto flex min-h-[60px] max-w-[1440px] items-center justify-between px-4 sm:min-h-[70px] md:min-h-[80px] lg:min-h-[90px]">
          <a data-component-id="src/components/ui/Header.tsx:22:10" data-component-path="src/components/ui/Header.tsx" data-component-line="22" data-component-end-line="38" data-component-file="Header.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%2F%22%7D" href="/" aria-label="Go to homepage">
            <Image data-component-id="src/components/ui/Header.tsx:23:12" data-component-path="src/components/ui/Header.tsx" data-component-line="23" data-component-end-line="37" data-component-file="Header.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22src%22%3A%22%5Bvar%3AlogoSrc%5D%22%2C%22alt%22%3A%22%5Bvar%3AlogoAlt%5D%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20h-auto%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20w-%5B50px%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20object-contain%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20sm%3Aw-%5B65px%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20md%3Aw-%5B80px%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20lg%3Aw-%5B95px%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20%22%7D"
              src={logoSrc}
              alt={logoAlt}
              width={160}
              height={70}
              priority
              className="
                h-auto
                w-[50px]
                object-contain
                sm:w-[65px]
                md:w-[80px]
                lg:w-[95px]
              "
            />
          </a>

          <button data-component-id="src/components/ui/Header.tsx:40:10" data-component-path="src/components/ui/Header.tsx" data-component-line="40" data-component-end-line="56" data-component-file="Header.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20min-h-%5B40px%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20rounded-full%20bg-%5B%239000ff%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20px-5%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20text-%5B14px%5D%20font-bold%20text-white%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20shadow-%5B0_6px_20px_rgba(0%2C0%2C0%2C0.3)%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20transition-all%20duration-200%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20hover%3Ascale-%5B1.03%5D%20hover%3Abg-%5B%23a020ff%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20active%3Ascale-%5B0.98%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20sm%3Amin-h-%5B44px%5D%20sm%3Apx-6%20sm%3Atext-%5B16px%5D%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%20%20lg%3Apx-8%5Cn%20%20%20%20%20%20%20%20%20%20%20%20%22%2C%22textContent%22%3A%22Contact%20us%22%7D"
            onClick={() => setIsPopupOpen(true)}
            className="
              min-h-[40px]
              rounded-full bg-[#9000ff]
              px-5
              text-[14px] font-bold text-white
              shadow-[0_6px_20px_rgba(0,0,0,0.3)]
              transition-all duration-200
              hover:scale-[1.03] hover:bg-[#a020ff]
              active:scale-[0.98]
              sm:min-h-[44px] sm:px-6 sm:text-[16px]
              lg:px-8
            "
          >
            Contact us
          </button>
        </div>
      </header>

      <PopupForm data-component-id="src/components/ui/Header.tsx:60:6" data-component-path="src/components/ui/Header.tsx" data-component-line="60" data-component-end-line="60" data-component-file="Header.tsx" data-component-name="PopupForm" data-component-content="%7B%22elementName%22%3A%22PopupForm%22%7D" isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} />
    </>
  );
}
